// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--622b5";
export var centeredBtnBlock = "main-module--centered-btn-block--ab9c6";
export var container = "main-module--container--1b53e";
export var hugs = "main-module--hugs--ce9a7";
export var listTriple = "main-module--list-triple--7eb9e";
export var orange = "main-module--orange--407e9";
export var shadow = "main-module--shadow--9aa01";
export var title = "main-module--title--503b9";
export var violet = "main-module--violet--9998e";